import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  Box,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core';

import { usePageBallotCopyStyles as useStyles } from '../styles';
import AppInput from '../../../../common/AppInput';
import { isNumber } from '../../../../../helpers/OnlyNumbers';
import AuthorizeCheckbox from '../../../mis-compras/components/report-issue-view/forms/authorizeThird/AuthorizeCheckbox';
import LoadingButton from '../../../../common/LoadingButton';
import { useDispatch, useSelector } from 'react-redux';
import { bodyIssueTicketGenerator } from '../../../../../helpers/tickets/TicketsHelper';
import { createTicketNoProduct } from '../../../../../redux/actions/TicketActions';
import { useHistory } from 'react-router-dom';
import { REQUEST_NOT_PRODUCT_TICKET } from '../../../../../constants/Routes';

const motives = [
  { text: 'Canjear premio', id: '38' },
  { text: 'Ver estado de solicitud de canje', id: '39' },
  { text: 'Ingresar una boleta', id: '40' },
  { text: 'Cambiar fecha de matrimonio', id: '41' },
  { text: 'Recuperar contraseña', id: '42' },
];

const ClubsGeneralProblems = (props) => {
  const { mobile, type } = props;
  const [selectedClubProblem, setSelectedClubProblem] = useState('');
  const [successClubNumber, setSuccessClubNumber] = useState(false);
  const [errorClubNumber, setErrorClubNumber] = useState(false);
  const [checked, setChecked] = useState(false);
  const [successClubComment, setSuccessClubComment] = useState(false);
  const [errorClubComment, setErrorClubComment] = useState(false);
  const [clubNumber, setClubNumber] = useState('');
  const [commentHelper, setCommentHelper] = useState('0/200');
  const [comment, setComment] = useState('');
  const classes = useStyles({ mobile });
  const { ticketNoProductStatus } = useSelector(
    (innerState) => innerState.ticketReducer,
  );
  const { profile } = useSelector((state) => state.profileReducer);
  const history = useHistory();
  const dispatch = useDispatch();

  const onSent = () => {
    const body = bodyIssueTicketGenerator({
      profile,
      type,
      motiveId: selectedClubProblem,
      comment: `${clubNumber && `Codigo: ${clubNumber} - `}${comment}`,
    });
    dispatch(createTicketNoProduct(body));
  };

  const changeRadio = (e) => setSelectedClubProblem(e.target.value);

  const validateClubNumber = (event) => {
    const { value } = event.target;
    setClubNumber(value);
    if ((isNumber(value) && value.length === 9) || !value.length) {
      setSuccessClubNumber(true);
      setErrorClubNumber(false);
    } else {
      setSuccessClubNumber(false);
      setErrorClubNumber(true);
    }
  };

  const changeCommentClub = (event) => {
    const { value } = event.target;
    if (value.length > 200 || value.length < 20) {
      setErrorClubComment(true);
      setSuccessClubComment(false);
    } else {
      setErrorClubComment(false);
      setSuccessClubComment(true);
    }
    setComment(value);
    setCommentHelper(`${value.length}/200`);
  };

  useEffect(() => {
    if (ticketNoProductStatus === 'succeded') {
      setComment('');
      setClubNumber('');
      setSelectedClubProblem('');
      setErrorClubComment(false);
      setErrorClubComment(false);
      setSuccessClubComment(false);
      setSuccessClubComment(false);
      history.push(REQUEST_NOT_PRODUCT_TICKET);
    }
  }, [ticketNoProductStatus]);

  return (
    <Box
      className={classes.container}
      margin={mobile ? '0px -16px' : '0px 50px'}
      width={mobile ? 'auto' : '75%'}
    >
      <Typography className={classes.titleRadioButton}>
        Selecciona una opción:
      </Typography>
      <RadioGroup value={selectedClubProblem} onChange={changeRadio}>
        {motives.map((motive, index) => (
          <FormControlLabel
            key={index}
            value={motive.id}
            control={<Radio color="primary" />}
            label={motive.text}
            data-cy={`clubProblemValue-${index}`}
            className={classes.radioButton}
          />
        ))}
      </RadioGroup>
      <AppInput
        name="clubCode"
        helperText={'Ingresa 9 dígitos (opcional)'}
        label={'Código de clubes'}
        value={clubNumber}
        onClick={() => {}}
        onBlur={validateClubNumber}
        onChange={validateClubNumber}
        error={errorClubNumber}
        errorMessage={'Deben ser 9 dígitos'}
        success={successClubNumber}
      />
      <AppInput
        name="comment"
        helperText={commentHelper}
        label="Dejar comentario..."
        error={errorClubComment}
        errorMessage={commentHelper}
        success={successClubComment}
        value={comment}
        onClick={() => {}}
        onBlur={changeCommentClub}
        onChange={changeCommentClub}
        multiline
      />
      <AuthorizeCheckbox
        idComplement="clubsGeneralForm"
        disabled={
          selectedClubProblem === '' || !successClubComment || errorClubNumber
        }
        onCheck={() => setChecked(!checked)}
      />
      <LoadingButton
        variant="contained"
        color="primary"
        text="Enviar"
        name="SentClubGeneralProblem"
        className={classes.button}
        disabled={
          selectedClubProblem === '' ||
          !successClubComment ||
          errorClubNumber ||
          !checked
        }
        onClick={onSent}
        loading={ticketNoProductStatus === 'loading'}
      />
    </Box>
  );
};

ClubsGeneralProblems.propTypes = {
  mobile: PropTypes.bool,
  type: PropTypes.string,
};

export default ClubsGeneralProblems;
